import RefreshData from './refresh-data';

export default RefreshData;